$(function () {
	// ---- helpers (sécurisés) ----
	function warnOnceFactory() {
		const seen = new Set();
		return function warnOnce(key, ...args) {
			if (seen.has(key)) return;
			seen.add(key);
			console.warn(...args);
		};
	}
	const warnOnce = warnOnceFactory();

	function readVar(el, name) {
		if (!el) return 0;
		const v = getComputedStyle(el).getPropertyValue(name);
		const n = parseFloat(v);
		return Number.isFinite(n) ? n : 0;
	}

	function safeScrollTo(top, behavior = "auto") {
		// Empêche NaN/Infinity et clamp aux bornes
		if (!Number.isFinite(top)) return;
		const maxTop = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
		const clamped = Math.min(Math.max(0, top), maxTop);
		try {
			window.scrollTo({ top: clamped, behavior });
		} catch (e) {
			// fallback vieux navigateurs
			window.scrollTo(0, clamped);
		}
	}

	// ---- init ----
	const $wrap = $(".module-stickycards").first();
	if (!$wrap.length) {
		// Rien à faire, on sort sans erreur
		return;
	}

	const host = $wrap.get(0);
	const $cards = $wrap.find(".elements-sticky-cards");

	if (!$cards.length) {
		warnOnce("no-cards", "[stickycards] .elements-sticky-cards introuvable dans .module-stickycards");
		return;
	}

	// Optionnel : si tu veux garder ce comportement
	if ($(".module-wrap .module-stickycards").length) {
		$(".module-wrap").css("overflow", "visible");
		// évite de casser si scrollTo est bloqué/bug
		safeScrollTo(0, "auto");
	}

	// 1) CSS vars
	try {
		host.style.setProperty("--count", String($cards.length));
	} catch (e) {
		warnOnce("css-var", "[stickycards] impossible de set --count", e);
	}

	$cards.each(function (i) {
		try {
			this.style.setProperty("--i", String(i));
		} catch (e) {}
	});

	// 2) stocker la position initiale (utilise un vrai data-attribute cohérent)
	function computeInitialScrollPositions() {
		$cards.each(function () {
			try {
				const top = this.getBoundingClientRect().top + window.scrollY;
				// data-initial-scroll-pos en kebab-case (lisible via .data() jQuery)
				this.setAttribute("data-initial-scroll-pos", String(Math.round(top)));
			} catch (e) {}
		});
	}

	// calc après load + recalcul si images/fonts bougent le layout
	setTimeout(computeInitialScrollPositions, 300);
	$(window).on("load", function () {
		setTimeout(computeInitialScrollPositions, 50);
	});

	// 3) update (protégé + perf)
	let lastApplied = -2; // évite de re-toucher le DOM si rien ne change

	function update() {
		// si le wrap est detached ou display none, on sort
		if (!document.documentElement.contains(host)) return;
		if (!$wrap.is(":visible")) return;

		const baseTop = readVar(host, "--baseTop");
		const gap = readVar(host, "--gap");
		const headH = readVar(host, "--headerH");

		let lastStuck = -1;

		// lecture layout (rect) — on garde mais on réduit le DOM write
		$cards.each(function (i, el) {
			const stickyTop = baseTop + i * (headH + gap);
			const rectTop = el.getBoundingClientRect().top;
			if (rectTop <= stickyTop + 1) lastStuck = i;
		});

		// rien n’a changé -> pas de classList churn
		if (lastStuck === lastApplied) return;
		lastApplied = lastStuck;

		// reset + apply
		$cards.removeClass("is-collapsed is-active");
		if (lastStuck >= 0) {
			$cards.each(function (i, el) {
				if (i < lastStuck) $(el).addClass("is-collapsed");
			});
			$cards.eq(lastStuck).addClass("is-active");
		}
	}

	// 4) throttle scroll/resize
	let ticking = false;
	const onTick = function () {
		ticking = false;
		try {
			update();
		} catch (e) {
			// En prod tu peux désactiver le script après 1 crash
			warnOnce("update-crash", "[stickycards] update() a crash, script neutralisé", e);
			$(window).off("scroll resize", onScrollResize);
		}
	};
	const onScrollResize = function () {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(onTick);
	};

	$(window).on("scroll resize", onScrollResize);

	// 5) click -> scroll vers la position initiale (corrigé)
	$wrap.on("click", ".sc-title", function (e) {
		const $card = $(this).closest(".elements-sticky-cards");
		if (!$card.length) return;

		// jQuery .data lit data-initial-scroll-pos automatiquement
		const top = Number($card.data("initialScrollPos"));
		if (!Number.isFinite(top)) {
			warnOnce("bad-top", "[stickycards] data-initial-scroll-pos invalide", $card.get(0));
			return;
		}

		safeScrollTo(top, "smooth");
	});

	// init
	try {
		update();
	} catch (e) {
		console.error("[stickycards] init crash", e);
	}
});